// extracted by mini-css-extract-plugin
export default {"button":"MenuCreateNew_button__mjf9J","business":"MenuCreateNew_business__faTTv","container":"MenuCreateNew_container__frseX"};